<template>
  <div style="display:flex;justify-content:space-between;" class="toolbar_wrapper">
    <div :style="'display:flex;justify-content:'+leftAlign" class="tool-left">
      <slot name="left"></slot>
    </div>
    <div :style="'display:flex;justify-content:'+centerAlign" class="tool-center">
      <slot name="center"></slot>
    </div>
    <div :style="'display:flex;justify-content:'+rightAlign" class="tool-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "s-toolbar",
  props: {
    rows: {
      type: Number,
      default: 1
    },
    la: {
      type: String,
      default: null
    },
    ca: {
      type: String,
      default: null
    },
    ra: {
      type: String,
      default: null
    }
  },
  computed: {
    leftAlign() {
      if (this.la == "l") return "flex-start";
      if (this.la == "c") return "center";
      return "flex-end";
    },
    centerAlign() {
      if (this.ca == "l") return "flex-start";
      if (this.ca == "r") return "flex-end";
      return "center";
    },
    rightAlign() {
      if (this.ra == "c") return "center";
      if (this.ra == "r") return "flex-end";

      return "flex-start";
    }
  },
  methods: {
    init() {}
  }
};
</script>

<style>
div.toolbar_wrapper {
  box-shadow: 2px 2px 3px;
  padding-top: 3px;
  padding-bottom: 5px;
  background-color: #095b69;
}
</style>

